module.exports = __webpack_public_path__ + "img/empty.2672f715.svg";